export const environment = {
  production: true,
  apiBaseUrl: 'https://service-batterypassport-uat.tesvolt.com/api/v1',
  keycloak: {
    url: 'https://service-energyidentity-uat.tesvolt.com',
    realm: 'Tesvolt',
    clientId: 'Tesvolt.BatteryPassport.Portal'
  }
};
